var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tarif
    ? _c(
        "b-modal",
        {
          attrs: { size: "lg", title: _vm.title, "hide-footer": "" },
          model: {
            value: _vm.afficherModal,
            callback: function($$v) {
              _vm.afficherModal = $$v
            },
            expression: "afficherModal"
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("div", { key: _vm.key, staticClass: "container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 flex-center-space-between" },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "codeProduit" } }, [
                        _vm._v("Code produit")
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tarif.Reference,
                            expression: "tarif.Reference"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          id: "codeProduit",
                          type: "text",
                          readonly: ""
                        },
                        domProps: { value: _vm.tarif.Reference },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.tarif,
                              "Reference",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm.tarif.idFourn && _vm.tarif.Reference
                      ? _c("BoutonFicheTechnique", {
                          staticClass: "flex-end",
                          attrs: {
                            fournisseurId: _vm.tarif.idFourn,
                            reference: _vm.tarif.Reference
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "designation" } }, [
                      _vm._v("Désignation produit du fournisseur")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.tarif.Designation,
                          expression: "tarif.Designation"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "designation", type: "text", readonly: "" },
                      domProps: { value: _vm.tarif.Designation },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.tarif,
                            "Designation",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "marque" } }, [
                      _vm._v("Marque")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.tarif.Marque,
                          expression: "tarif.Marque"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "marque", type: "text", readonly: "" },
                      domProps: { value: _vm.tarif.Marque },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.tarif, "Marque", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "ingredient" } }, [
                      _vm._v("Ingrédient")
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ingredient.nom,
                          expression: "ingredient.nom"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "ingredient", type: "text", readonly: "" },
                      domProps: { value: _vm.ingredient.nom },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.ingredient, "nom", $event.target.value)
                        }
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    { staticClass: "flex-start" },
                    [
                      _c("div", { staticClass: "label-input" }, [
                        _vm._v("PCB :")
                      ]),
                      _c("InputNumber", {
                        staticStyle: { width: "50px" },
                        attrs: { typeFiltre: "quantite", readonly: "" },
                        model: {
                          value: _vm.tarif.PCB,
                          callback: function($$v) {
                            _vm.$set(_vm.tarif, "PCB", $$v)
                          },
                          expression: "tarif.PCB"
                        }
                      }),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(
                            _vm._s(_vm.plurielUC(_vm.tarif.PCB, _vm.prod.UC))
                          )
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "label-input",
                          staticStyle: { "margin-left": "15px" }
                        },
                        [_vm._v("PU HT :")]
                      ),
                      _c("InputNumber", {
                        staticStyle: { width: "70px" },
                        attrs: { typeFiltre: "montant", readonly: "" },
                        model: {
                          value: _vm.tarif.PU,
                          callback: function($$v) {
                            _vm.$set(_vm.tarif, "PU", $$v)
                          },
                          expression: "tarif.PU"
                        }
                      }),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v("€" + _vm._s(this.unitePrix(1)))
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "label-input",
                          staticStyle: { "margin-left": "15px" }
                        },
                        [_vm._v("Montant HT :")]
                      ),
                      _c("InputNumber", {
                        staticStyle: { width: "90px" },
                        attrs: { typeFiltre: "montant", readonly: "" },
                        model: {
                          value: _vm.tarif.PHT,
                          callback: function($$v) {
                            _vm.$set(_vm.tarif, "PHT", $$v)
                          },
                          expression: "tarif.PHT"
                        }
                      }),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v("€" + _vm._s(this.unitePrix(_vm.tarif.PCB)))
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-end",
                      staticStyle: { "margin-top": "15px" }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(
                            "Dans " +
                              _vm._s(_vm.tarif.PCB) +
                              " " +
                              _vm._s(
                                _vm.plurielUC(_vm.tarif.PCB, _vm.prod.UC)
                              ) +
                              " je vais avoir "
                          )
                        ])
                      ]),
                      _c("InputNumber", {
                        staticClass: "saisieRepartition",
                        staticStyle: { width: "60px" },
                        attrs: {
                          value: _vm.arrondiNombre(
                            _vm.tarif.parPCE * _vm.tarif.PCB,
                            3
                          ),
                          typeFiltre: "quantite",
                          readonly: ""
                        }
                      }),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.plurielUC(
                                _vm.tarif.parPCE * _vm.tarif.PCB,
                                "Pièce"
                              ) + ", "
                            )
                          )
                        ])
                      ]),
                      _c("InputNumber", {
                        staticClass: "saisieRepartition",
                        staticStyle: { width: "60px" },
                        attrs: {
                          value: _vm.arrondiNombre(
                            _vm.tarif.parKg * _vm.tarif.PCB,
                            3
                          ),
                          typeFiltre: "quantite",
                          readonly: ""
                        }
                      }),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm.estInvalidePour("KG", _vm.tarif.parKg)
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass: "error fas fa-exclamation-circle",
                                attrs: { title: "Cette valeur devrait être 1" }
                              })
                            : _vm._e(),
                          _vm._v("Kg, ")
                        ])
                      ]),
                      _c("InputNumber", {
                        staticClass: "saisieRepartition",
                        staticStyle: { width: "60px" },
                        attrs: {
                          value: _vm.arrondiNombre(
                            _vm.tarif.parL * _vm.tarif.PCB,
                            3
                          ),
                          typeFiltre: "quantite",
                          readonly: ""
                        }
                      }),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c("span", { staticClass: "input-group-text" }, [
                          _vm.estInvalidePour("L", _vm.tarif.parL)
                            ? _c("i", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true }
                                  }
                                ],
                                staticClass: "error fas fa-exclamation-circle",
                                attrs: { title: "Cette valeur devrait être 1" }
                              })
                            : _vm._e(),
                          _vm._v(
                            _vm._s(
                              _vm.plurielUC(
                                _vm.tarif.parL * _vm.tarif.PCB,
                                "Litre"
                              ) + "."
                            )
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  !_vm.tarif.parPCE && !_vm.tarif.parKg && !_vm.tarif.parL
                    ? _c("div", { staticClass: "error" }, [
                        _vm._v(
                          "Attention, les répartitions doivent être renseignées pour être prises en compte dans les calculs automatiques"
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "flex-end",
                      staticStyle: { "margin-top": "3px" }
                    },
                    [
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.phraseConversion(
                              _vm.tarif,
                              _vm.prod,
                              _vm.tarif.PCB
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _c("div", { staticClass: "flex-end" }, [
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.phraseConversion(
                            _vm.tarif,
                            _vm.prod,
                            1.5 * _vm.tarif.PCB
                          )
                        )
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }